import { buildJobsReportQuery } from '@/features/reports/lib/jobs-report-search-params'
import type { JobsReportSort } from '@/features/reports/lib/jobs-report-sort'
import type {
  AbortedJob,
  AbortedJobsReportFilters,
  AbortedJobsReportSummary,
  CompletedJob,
  CompletedJobsReportFilters,
  CompletedJobsReportSummary,
  JobsByPartnerReportSummary,
  ServiceLevelAgreementReportFilters,
  ServiceLevelAgreementReportSummary,
  SlaJob,
} from '@/features/reports/types/jobs-report'
import { apiPaginatedClientWithSummary } from '@/lib/api/api-client'

export const apiGetAbortedJobsReport = (
  filters?: AbortedJobsReportFilters,
  page = 1,
  sort?: JobsReportSort
) =>
  apiPaginatedClientWithSummary<AbortedJob[], AbortedJobsReportSummary>(
    `/api/v1/reports/aborted_jobs${buildJobsReportQuery(filters, page, sort)}`
  )

export const apiGetAbortedJobsByPartnerReport = (
  filters?: AbortedJobsReportFilters,
  page = 1,
  sort?: JobsReportSort
) =>
  apiPaginatedClientWithSummary<AbortedJob[], JobsByPartnerReportSummary>(
    `/api/v1/reports/aborted_jobs_by_partner${buildJobsReportQuery(filters, page, sort)}`
  )

export const apiGetCompletedJobsReport = (
  filters?: CompletedJobsReportFilters,
  page = 1,
  sort?: JobsReportSort
) =>
  apiPaginatedClientWithSummary<CompletedJob[], CompletedJobsReportSummary>(
    `/api/v1/reports/completed_jobs${buildJobsReportQuery(filters, page, sort)}`
  )

export const apiGetCompletedJobsByPartnerReport = (
  filters?: CompletedJobsReportFilters,
  page = 1,
  sort?: JobsReportSort
) =>
  apiPaginatedClientWithSummary<CompletedJob[], JobsByPartnerReportSummary>(
    `/api/v1/reports/completed_jobs_by_partner${buildJobsReportQuery(filters, page, sort)}`
  )

export const apiGetServiceLevelAgreementReport = (
  filters?: ServiceLevelAgreementReportFilters,
  page = 1,
  sort?: JobsReportSort
) =>
  apiPaginatedClientWithSummary<
    SlaJob[],
    ServiceLevelAgreementReportSummary
  >(
    `/api/v1/reports/service_level_agreements${buildJobsReportQuery(filters, page, sort)}`
  )

export const apiGetServiceLevelAgreementByPartnerReport = (
  filters?: ServiceLevelAgreementReportFilters,
  page = 1,
  sort?: JobsReportSort
) =>
  apiPaginatedClientWithSummary<SlaJob[], JobsByPartnerReportSummary>(
    `/api/v1/reports/service_level_agreements_by_partner${buildJobsReportQuery(filters, page, sort)}`
  )
